import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaVideo,
  FaBullhorn,
  FaEye,
  FaRocket,
  FaMobileAlt,
  FaStar,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const DigitalMarketingVideosInAlBarsha = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Digital Marketing Videos in Al Barsha" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Amplify Your Brand</Subheading>}
        heading={
          <Heading>
            Professional{" "}
            <span tw="text-primary-500">Digital Marketing Videos</span> in Al
            Barsha
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we create professional digital marketing videos
            in **Al Barsha**, combining compelling storytelling with
            high-quality visuals to boost your brand’s online presence. Engage
            your audience with videos that deliver results.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1616469829941-c7200edec809?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2670&q=80", // Professional video shoot
          "https://images.unsplash.com/photo-1601506521941-ca8a9ea2f0db?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2670&q=80", // Creative video production
          "https://images.unsplash.com/photo-1492691527719-9d1e07e534b4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2671&q=80", // Dynamic video content
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Create Your Video"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Expert Video Marketing Services in Al Barsha"
        description="We produce digital marketing videos with impact and precision."
        cards={[
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Cinematic Quality",
            description: "High-definition videos with professional editing.",
          },
          {
            icon: <FaBullhorn color="#ff5464" size={40} />,
            title: "Engaging Storytelling",
            description: "Narratives that captivate and convert.",
          },

          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Brand Visibility",
            description: "Videos designed to enhance your online reach.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Fast Turnaround",
            description: "Quick delivery without compromising quality.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Mobile Optimized",
            description: "Videos tailored for all devices.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted Expertise",
            description: "Al Barsha’s choice for video marketing.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Professional Video Production Process"
        description={
          <Description>
            We create impactful digital marketing videos with a streamlined
            approach:
            <ul tw="mt-4 list-disc pl-6">
              <li>Consultation: Understand your brand and goals.</li>
              <li>Scripting: Craft a compelling narrative.</li>
              <li>Filming: Capture high-quality footage.</li>
              <li>Editing: Polish with professional effects and sound.</li>
              <li>Delivery: Provide ready-to-share videos.</li>
              <li>Support: Offer ongoing optimization and updates.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1496559249665-c7e2874707ea?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2670&q=80", // Storyboarding session
          "https://images.unsplash.com/photo-1603729340594-9e0c31e0063b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2670&q=80", // Camera equipment closeup
          "https://images.unsplash.com/photo-1580537659466-0a9bfa916a54?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2670&q=80", // Video editing process
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Video Marketing Wins in Al Barsha"
        description="Our videos have transformed brand engagement."
        cards={[
          {
            icon: <FaBullhorn color="#ff5464" size={40} />,
            title: "Engagement Surge",
            description: "Tripled audience interaction with one video.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Brand Reach",
            description: "Boosted visibility for an Al Barsha business.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Satisfaction",
            description: "95% approval from marketing clients.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready for Impactful Videos?</Subheading>}
        heading="Digital Marketing Videos in Al Barsha"
        description={
          <Description>
            Partner with MilaajBrandset for professional digital marketing
            videos in Al Barsha. Get engaging, high-quality videos that elevate
            your brand—contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1583217874484-9e3a5ee3dd5e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2670&q=80", // Dubai cityscape/skyline
          "https://images.unsplash.com/photo-1524649466382-c1c6b5b6e9cf?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2574&q=80", // Creative marketing team
          "https://images.unsplash.com/photo-1551218372-a8dadaee604a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2670&q=80", // Professional camera equipment
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
